import { useTranslation } from 'react-i18next';
import { mdiFileDocument } from '@mdi/js';

import {
    Card,
    CardActionLinkArea,
    CardActions,
    CardContent,
    CardMedia,
    CardMediaIcon,
    CardSubtitle,
    CardTitle,
} from 'common/components/Card';
import { Chip, ChipGroup } from 'common/components/Chip';
import { Icon } from 'common/components/Icon';
import { IFeaturedArticleCardFragment } from 'graphql/types';

interface IProps {
    article: IFeaturedArticleCardFragment;
}

export const FeaturedArticleCard = ({ article }: IProps) => {
    const [translate] = useTranslation();

    const { id, title, description, thumbnail, headerImage } = article;

    const cardImage = thumbnail?.url || headerImage?.url;

    return (
        <Card>
            <CardActionLinkArea params={{ id }} to="LIBRARY_ARTICLE">
                {cardImage ? (
                    <CardMedia aria-label={title} image={cardImage} />
                ) : (
                    <CardMedia
                        aria-label={title}
                        sx={{
                            bgcolor: 'warning.main',
                            color: 'common.white',
                        }}
                    >
                        <CardMediaIcon>
                            <Icon path={mdiFileDocument} size="2.4rem" />
                        </CardMediaIcon>
                    </CardMedia>
                )}

                <CardContent>
                    <CardTitle>{title}</CardTitle>
                    {!!description && (
                        <CardSubtitle>{description}</CardSubtitle>
                    )}
                </CardContent>

                <CardActions>
                    <ChipGroup>
                        <Chip
                            bgColor="warning"
                            label={translate('featuredArticle')}
                        />
                    </ChipGroup>
                </CardActions>
            </CardActionLinkArea>
        </Card>
    );
};
